import type { CtwFetchFn } from '@ctw/shared/context/ctw-context';
import { type Env, getBffApiBaseUrl } from '@ctw/shared/utils/environments';

export interface RiskGapStatusUpdateAttributes {
  status: string;
  substatuses?: Array<string>;
  note?: string;
}

export interface SubmitRiskGapStatusUpdateArgs {
  ctwFetch: CtwFetchFn;
  env: Env;
  authToken: string;
  riskGapId: string;
  // The caller's active builder. Required by the BFF API endpoint, which acts on it (rather than
  // the JWT's home builder) and verifies access when it differs.
  builderId: string;
  attributes: RiskGapStatusUpdateAttributes;
}

/**
 * Posts a risk-gap status update to the BFF API, returning the raw `ok`/`data` fetch result so
 * callers keep their own success/error handling.
 */
export const submitRiskGapStatusUpdate = ({
  ctwFetch,
  env,
  authToken,
  riskGapId,
  builderId,
  attributes,
}: SubmitRiskGapStatusUpdateArgs): ReturnType<CtwFetchFn> => {
  const url = `${getBffApiBaseUrl(env)}/v1/risk-gaps/${riskGapId}/status-updates`;

  return ctwFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      data: {
        type: 'risk-gap-status-update',
        attributes,
      },
      builderId,
    }),
  });
};
